/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_034: Question = {
  id: 'pres-034-plan-retablissement-especes',
  oldId: '48',
  title: 'Création d\'un plan de rétablissement d’une ou de plusieurs espèces sentinelles',
  number: '3.18',
  description: [''],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 4,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_pres_034__v3: Question = {
  ...question_pres_034,
  title: 'Contribuer à la mise en oeuvre d\'action pour la protection des espèces à statut précaire',
  number: '3.8',
  frequency: 4,
};

export const question_pres_034_v2: Question = question_pres_034;
export const question_pres_034_v3: Question = question_pres_034__v3;
